import { Box } from '@chakra-ui/react';

const PreviewEmptyPass = () => {
  return (
    <Box
      m="0 auto"
      w="343px"
      maxW="full"
      zIndex="1"
      maxWidth="330px"
      minH="350px"
      boxShadow="0px 6px 13px rgb(0 0 0 / 15%)"
      borderRadius="10px"
      bg="#EFEFEF"
      color="#29323A"
      alignItems="center"
      justifyContent="center"
      opacity="1"
    ></Box>
  );
};

export default PreviewEmptyPass;
